import axiosInstance from "../../scenes/utils/axiosInstance";
import { API_ENDPOINTS } from "../../config/api";

export default class PermissionGroupService {
  getRole = () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      return user.role;
    } catch (e) {
      return undefined;
    }
  };

  isDoctor = () => this.getRole() === "doctor";

  // Get all permission groups for admin doctor (with permission check)
  getAllGroups = async () => {
    try {
      const endpoint = this.isDoctor()
        ? API_ENDPOINTS.PERMISSION_GROUPS.ALL
        : API_ENDPOINTS.PERMISSION_GROUPS.ADMIN.ALL;
      const response = await axiosInstance.get(endpoint);
      return response.data;
    } catch (error) {
      console.error("Get all permission groups error:", error);
      throw error;
    }
  };

  // Get single permission group by ID (with permission check)
  getGroupById = async (groupId) => {
    try {
      const endpoint = this.isDoctor()
        ? API_ENDPOINTS.PERMISSION_GROUPS.BY_ID(groupId)
        : API_ENDPOINTS.PERMISSION_GROUPS.ADMIN.BY_ID(groupId);
      const response = await axiosInstance.get(endpoint);
      return response.data;
    } catch (error) {
      console.error("Get permission group by ID error:", error);
      throw error;
    }
  };

  // Create new permission group (with permission check)
  createGroup = async (groupData) => {
    try {
      const endpoint = this.isDoctor()
        ? API_ENDPOINTS.PERMISSION_GROUPS.CREATE
        : API_ENDPOINTS.PERMISSION_GROUPS.ADMIN.CREATE;
      const response = await axiosInstance.post(endpoint, groupData);
      return response.data;
    } catch (error) {
      console.error("Create permission group error:", error);
      throw error;
    }
  };

  // Update permission group (with permission check)
  updateGroup = async (groupId, groupData) => {
    try {
      const endpoint = this.isDoctor()
        ? API_ENDPOINTS.PERMISSION_GROUPS.UPDATE(groupId)
        : API_ENDPOINTS.PERMISSION_GROUPS.ADMIN.UPDATE(groupId);
      const response = await axiosInstance.put(endpoint, groupData);
      return response.data;
    } catch (error) {
      console.error("Update permission group error:", error);
      throw error;
    }
  };

  // Delete permission group (with permission check)
  deleteGroup = async (groupId) => {
    try {
      const endpoint = this.isDoctor()
        ? API_ENDPOINTS.PERMISSION_GROUPS.DELETE(groupId)
        : API_ENDPOINTS.PERMISSION_GROUPS.ADMIN.DELETE(groupId);
      const response = await axiosInstance.delete(endpoint);
      return response.data;
    } catch (error) {
      console.error("Delete permission group error:", error);
      throw error;
    }
  };

  // Get doctor's assigned groups
  getDoctorGroups = async (doctorId) => {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.PERMISSION_GROUPS.DOCTOR_GROUPS(doctorId));
      return response.data;
    } catch (error) {
      console.error("Get doctor groups error:", error);
      throw error;
    }
  };

  // Assign permission group to doctor
  assignGroupToDoctor = async (doctorId, groupId) => {
    try {
      const response = await axiosInstance.post(API_ENDPOINTS.PERMISSION_GROUPS.ASSIGN_DOCTOR, {
        doctorId,
        groupId
      });
      return response.data;
    } catch (error) {
      console.error("Assign group to doctor error:", error);
      throw error;
    }
  };

  // Remove permission group from doctor
  removeGroupFromDoctor = async (doctorId, groupId) => {
    try {
      const response = await axiosInstance.delete(API_ENDPOINTS.PERMISSION_GROUPS.REMOVE_DOCTOR(doctorId, groupId));
      return response.data;
    } catch (error) {
      console.error("Remove group from doctor error:", error);
      throw error;
    }
  };

  // Get available permission resources and operations
  getPermissionStructure = () => {
    return {
      // Admin doctor managing other doctors - uses can_own_* permissions
      // Only for doctor type groups (normal doctors)
      doctor: {
        own_patients: ['create', 'update', 'view', 'delete'],
        own_form_answers: ['create', 'update', 'view', 'delete'],
        own_mr: ['create', 'view', 'delete'],
        own_patient_files: ['upload', 'update', 'view', 'delete'],
        own_files: ['create', 'update', 'view', 'delete'],
        own_forms: ['create', 'update', 'view', 'delete'],
        own_scoring_formulas: ['create', 'update', 'view', 'delete'],
        own_segmentation: ['create', 'view', 'delete'],
        own_invitations: ['create', 'update', 'view', 'delete'],
      }
    };
  };

  // Get permission labels (user-friendly names)
  getPermissionLabels = () => {
    return {
      resources: {
        own_patients: 'Own Patients',
        own_form_answers: 'Own Form Answers',
        own_mr: 'Own Medical Records',
        own_patient_files: 'Own Patient Files',
        own_files: 'Own Files',
        own_forms: 'Own Forms',
        own_scoring_formulas: 'Own Scoring Formulas',
        own_segmentation: 'Own Segmentation',
        own_invitations: 'Own Invitations',
      },
      operations: {
        create: 'Create',
        update: 'Update',
        view: 'View',
        delete: 'Delete',
        upload: 'Upload',
      }
    };
  };
}




